"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CoreRenderExecutor_1 = require("../../tree/core/CoreRenderExecutor");
const ColorUtils_1 = require("../../tree/ColorUtils");
const CoreRenderState_1 = require("../../tree/core/CoreRenderState");
class C2dCoreRenderExecutor extends CoreRenderExecutor_1.CoreRenderExecutor {
    constructor() {
        super(...arguments);
        this._mainRenderTexture = this.context.stage.getCanvas();
    }
    _renderQuadOperation(op) {
        const shader = op.getC2dShader();
        if (op.length || op.shader.addEmpty()) {
            const target = (this._renderTexture || this._mainRenderTexture);
            shader.beforeDraw(op, target);
            shader.draw(op, target);
            shader.afterDraw(op, target);
        }
    }
    _clearRenderTexture() {
        const context = this._getContext();
        const renderTexture = context.canvas;
        context.setTransform(1, 0, 0, 1, 0, 0);
        let clearColor = [0, 0, 0, 0];
        if (this._mainRenderTexture.context === context) {
            clearColor = this.context.stage.getClearColor();
        }
        if (clearColor) {
            if (!clearColor[0] && !clearColor[1] && !clearColor[2] && !clearColor[3]) {
                context.clearRect(0, 0, renderTexture.width, renderTexture.height);
            }
            else {
                context.fillStyle = ColorUtils_1.ColorUtils.getRgbaStringFromArray(clearColor);
                // Do not use fillRect because it produces artifacts.
                context.globalCompositeOperation = "copy";
                context.beginPath();
                context.rect(0, 0, renderTexture.width, renderTexture.height);
                context.closePath();
                context.fill();
                context.globalCompositeOperation = "source-over";
            }
        }
    }
    _getContext() {
        if (this._renderTexture) {
            return this._renderTexture.context;
        }
        else {
            return this._mainRenderTexture.context;
        }
    }
    _restoreContext() {
        const context = this._getContext();
        context.restore();
        context.save();
        context.scissor = undefined;
    }
    _setScissor(area) {
        const context = this._getContext();
        if (!CoreRenderState_1.CoreRenderState.scissorsEqual(context.scissor, area)) {
            // Clipping is stored in the canvas context state.
            // We can't reset clipping alone so we need to restore the full context.
            this._restoreContext();
            const pixelRatio = this.context.stage.getPixelRatio();
            if (area) {
                context.beginPath();
                context.rect(Math.round(area[0] * pixelRatio), Math.round(area[1] * pixelRatio), Math.round(area[2] * pixelRatio), Math.round(area[3] * pixelRatio));
                context.closePath();
                context.clip();
            }
            context.scissor = area;
        }
    }
}
exports.C2dCoreRenderExecutor = C2dCoreRenderExecutor;
//# sourceMappingURL=C2dCoreRenderExecutor.js.map